module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Medium.70830fa4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Medium.ttf
// module id = 2541
// module chunks = 7